import React from 'react';
import c from 'classnames';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { Breadcrumbs, WysiwygField } from '../../../../components';
import type { NodeFaqProps } from '..';

type NodeFaqPageProps = Omit<NodeFaqProps, 'viewMode'>;

const NodeFaqPage: React.FC<NodeFaqPageProps> = ({ entity, className }) => {
  const faq = entity.toJS();
  const title = faq.title[0].value;
  const body = faq.body[0]?.processed;

  const classes = c('NodeFaqPage', 'NodeFaq', className);

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <Container>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
            <div className="content-section mt-0">
              <h1 itemProp="name">
                {title}
              </h1>

              <WysiwygField
                property="schema:text"
                html={body}
              />
            </div>
          </div>
        </div>
      </Container>
    </article>
  );
};

export default NodeFaqPage;
